module.exports = __webpack_public_path__ + "static/media/OnBoarding_banor_tpOnboardingSakerhet.532d6bc3.png";